import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayout = styled(Paper)(({ theme }) => ({
    height: `calc(100% - 52px)`,
    display: "grid",
    gridTemplateRows: "58px 1fr",
    borderRadius: 0,
    border: 0,
    backgroundColor: theme.palette.background.default,
    overflow: "hidden"
}))

export default TicketAdvancedLayout;
